import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
const API_URL = "/api";
const DashboardRFQList = () => {
  const [rfqs, setRfqs] = useState([]);
  const [user, setUser] = useState(null);
  const [clientOnboarding, setClientOnboarding] = useState(null);
  const [allClients, setAllClients] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  
  useEffect(() => {
    fetchProfileAndTopRFQs();
  }, []);
  
  const fetchProfileAndTopRFQs = async () => {
    try {
      // 1. Get profile
      const profileRes = await fetch(`${API_URL}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const profileData = await profileRes.json();
      if (!profileData.success) throw new Error("Failed to fetch profile");
      setUser(profileData.user);
      console.log("=== USER PROFILE ===");
      console.log("UserID:", profileData.user.UserID);
      console.log("Username:", profileData.user.Username);
      console.log("Role:", profileData.user.Role);
      
      // 2. Fetch all RFQs
      console.log("=== FETCHING RFQS ===");
      const res = await fetch(`${API_URL}/rfqs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let data = await res.json();
      console.log("Total RFQs fetched:", data.length);
      
      // Log all RFQs with their vendor codes
      console.log("=== ALL RFQS ===");
      data.forEach(rfq => {
        console.log(`RFQ ID: ${rfq.id}, RFQ No: ${rfq.rfq_no}, Vendor Code: ${rfq.vendor_code}`);
      });
      
      // 3. Process RFQs based on user role
      if (profileData.user.Role === "Vendoruser") {
        // For vendor users, fetch client data and filter RFQs
        console.log("=== FETCHING CLIENT FOR VENDOR USER ===");
        console.log("Fetching for UserID:", profileData.user.UserID);
        
        const clientRes = await fetch(`${API_URL}/clients?user_id=${profileData.user.UserID}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const clientData = await clientRes.json();
        console.log("Client onboarding response for user:", clientData);
        
        let clientInfo = null;
        if (clientData && clientData.length > 0) {
          // Check if any of the client records match the user's ID
          const matchingClient = clientData.find(client => 
            String(client.user_id) === String(profileData.user.UserID)
          );
          
          if (matchingClient) {
            clientInfo = matchingClient;
            setClientOnboarding(clientInfo);
            console.log("=== MATCHING CLIENT FOUND ===");
            console.log("Client Info:", clientInfo);
            console.log("Client user_id:", clientInfo.user_id);
            console.log("Client vendor_code:", clientInfo.vendor_code);
          } else {
            console.log("=== NO MATCHING CLIENT FOUND ===");
            console.log("Client data exists but none match user ID:", profileData.user.UserID);
            console.log("Available client IDs:", clientData.map(c => c.user_id));
          }
        } else {
          console.log("=== NO CLIENT DATA FOUND FOR USER ===");
          console.log("No client onboarding records found for user:", profileData.user.UserID);
        }
        
        // Filter RFQs for vendor user
        if (clientInfo && clientInfo.vendor_code) {
          console.log("=== FILTERING RFQS FOR VENDOR USER ===");
          console.log("Filtering for vendor_code:", clientInfo.vendor_code);
          
          data = data.filter(rfq => {
            const matches = String(rfq.vendor_code) === String(clientInfo.vendor_code);
            console.log(`RFQ ${rfq.rfq_no} (vendor_code: ${rfq.vendor_code}) matches ${clientInfo.vendor_code}: ${matches}`);
            return matches;
          });
          
          console.log("=== FILTERED RFQS ===");
          console.log(`RFQs after filtering: ${data.length}`);
          data.forEach(rfq => {
            console.log(`RFQ ID: ${rfq.id}, RFQ No: ${rfq.rfq_no}, Vendor Code: ${rfq.vendor_code}`);
          });
        } else {
          console.log("=== NO VENDOR CODE FOUND FOR VENDOR USER ===");
          console.log("Vendor user has no client info or vendor_code");
          data = [];
        }
      } else if (profileData.user.Role === "vendoradmin" || profileData.user.Role === "superadmin") {
        // For admin users, show all RFQs without filtering
        console.log("=== SHOWING ALL RFQS FOR ADMIN USER ===");
        console.log(`User role: ${profileData.user.Role}, showing all RFQs`);
      }
      
      // Only keep top 5
      setRfqs(data.slice(0, 5));
    } catch (error) {
      console.error("=== ERROR ===");
      console.error("Error fetching RFQs:", error);
      setRfqs([]);
    }
  };
  
  const handleSeeMore = () => {
    navigate("/rfq-items-master");
  };
  
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-[#2b6777]">Request for Quotation List</h2>
        <button
          className="text-sm px-4 py-2 bg-[#92C7CF] hover:bg-[#AAD7D9] text-white font-semibold rounded-lg shadow transition"
          onClick={handleSeeMore}
        >
          See More
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full bg-white rounded-2xl shadow-lg border-separate border-spacing-0">
          <thead>
            <tr>
              <th className="bg-[#AAD7D9] text-[#2b6777] px-6 py-4 text-center text-sm font-bold rounded-tl-2xl">RFQ No</th>
              <th className="bg-[#AAD7D9] text-[#2b6777] px-6 py-4 text-center text-sm font-bold">RFQ Date</th>
              <th className="bg-[#AAD7D9] text-[#2b6777] px-6 py-4 text-center text-sm font-bold">Vendor Name</th>
              <th className="bg-[#AAD7D9] text-[#2b6777] px-6 py-4 text-center text-sm font-bold">Status</th>
              <th className="bg-[#AAD7D9] text-[#2b6777] px-6 py-4 text-center text-sm font-bold rounded-tr-2xl">Payment Terms</th>
            </tr>
          </thead>
          <tbody>
            {rfqs.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-6 text-gray-500">
                  {user?.Role === "Vendoruser" && clientOnboarding?.vendor_code
                    ? `No RFQs found for vendor code: ${clientOnboarding.vendor_code}` 
                    : user?.Role === "vendoradmin" || user?.Role === "superadmin"
                    ? "No RFQs available"
                    : "No vendor information available"}
                </td>
              </tr>
            ) : (
              rfqs.map((rfq) => (
                <tr
                  key={rfq.id}
                  className="transition-all duration-300 group hover:bg-[#eaf6f6] hover:shadow-md border-b last:border-b-0 transform hover:scale-[1.01]"
                >
                  <td className="px-6 py-4 text-center text-sm font-mono whitespace-nowrap">{rfq.rfq_no}</td>
                  <td className="px-6 py-4 text-center text-sm whitespace-nowrap">
                    {rfq.rfq_date ? dayjs(rfq.rfq_date).format("YYYY-MM-DD") : "-"}
                  </td>
                  <td className="px-6 py-4 text-center text-sm whitespace-nowrap">{rfq.vendor_name}</td>
                  <td className="px-6 py-4 text-center text-sm">
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-bold shadow-sm ${
                        rfq.status === "Active"
                          ? "bg-[#52ab98] text-white"
                          : "bg-gray-300 text-gray-500"
                      }`}
                    >
                      {rfq.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center text-sm whitespace-nowrap">{rfq.payment_terms}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      
    </div>
  );
};
export default DashboardRFQList;